import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';
import { TemplateAssignedOffer } from '@recruitee/http-types';

@Injectable({ providedIn: 'root' })
export class AssignedOffersHttpClient {
  constructor(private httpApi: HttpApiService) {}

  public assignedOffersList(
    id: number,
    searchParams: { q: string | null; page: number; limit: number },
  ): Observable<{
    assignedOffers: TemplateAssignedOffer[];
    meta: { limit: number; page: number; totalCount: number };
  }> {
    return this.httpApi.get(`/referral/templates/${id}/assigned_offers`, searchParams);
  }
}
